export const css = {
    root: '_2g_OMV_t',
    heading: 'EqzHJ1N0',
    article: '_1Rwcyf-6',
    ' _key': 'apic-theme/apic/lcc-rcs/document'
};
export default css;
